
import { createTranslations } from '../../../i18n/types';

export default createTranslations({
  en: {
    userAgreement: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    refundPolicy: 'Refund Policy',
    paymentOrder: 'Payment Procedure',
    howItWorks: 'How the service works',
    contacts: 'Contacts',
    support: 'Support',
    refundTerms: 'Refund terms',
    digitalContent: 'Digital content',
    companyInfo: 'Magic Lucky Corporation\n2024-001445331\n312 W 2nd St, Ste 6031, Casper, WY 82601, USA',
  },
  ru: {
    userAgreement: 'Пользовательское соглашение',
    privacyPolicy: 'Политика конфиденциальности',
    refundPolicy: 'Политика возвратов',
    paymentOrder: 'Порядок оплаты',
    howItWorks: 'Как работает сервис',
    contacts: 'Контакты',
    support: 'Поддержка',
    refundTerms: 'Условия возврата',
    digitalContent: 'Получение цифрового контента',
    companyInfo: 'Magic Lucky Corporation\n2024-001445331\n312 W 2nd St, Ste 6031, Casper, WY 82601, USA',
  },
  uz: {
    userAgreement: 'Foydalanuvchi shartnomasi',
    privacyPolicy: 'Maxfiylik siyosati',
    refundPolicy: 'Qaytarish siyosati',
    paymentOrder: 'Toʻlov tartibi',
    howItWorks: 'Xizmat qanday ishlaydi',
    contacts: 'Kontaktlar',
    support: 'Qoʻllab-quvvatlash',
    refundTerms: 'Qaytarish shartlari',
    digitalContent: 'Raqamli kontent olish',
    companyInfo: 'Magic Lucky Corporation\n2024-001445331\n312 W 2nd St, Ste 6031, Casper, WY 82601, USA',
  },
  fa: {
    userAgreement: 'شرایط استفاده',
    privacyPolicy: 'سیاست حریم خصوصی',
    refundPolicy: 'سیاست بازگشت وجه',
    paymentOrder: 'روال پرداخت',
    howItWorks: 'سرویس چطور کار می‌کند',
    contacts: 'تماس',
    support: 'پشتیبانی',
    refundTerms: 'شرایط بازگشت وجه',
    digitalContent: 'محتوای دیجیتال',
    companyInfo: 'Magic Lucky Corporation\n2024-001445331\n312 W 2nd St, Ste 6031, Casper, WY 82601, USA',
  },
});
